import SuspiciousActivityAction from "@common/redux/actions/SuspiciousActivityAction";
import LoadingAction from "@common/redux/actions/LoadingAction";
import IncidentClient from "@common/api/IncidentClient";
import { mapToSelect } from "../forms";
import { handleError } from "@common/components/helpers/error";

export const fetchSuspiciousActivityMetaData = () => {
  LoadingAction.set(true).then(() => {
    IncidentClient.MetaData()
      .then((response) => {
        const { suspiciousActivityTypes } = response;
        const types = mapToSelect(suspiciousActivityTypes);
        SuspiciousActivityAction.dispatch({
          types: types,
        });
      })
      .catch((error) => {
        console.error(error);
        handleError(error);
      })
      .finally(() => {
        LoadingAction.set(false);
      });
  });
};
